import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  pirsom,
  handleCancelClick,
  increment,
  setPirsomId,
  advType,
}) => {
  const [newPirsom, setNewPirsom] = useState(pirsom);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewPirsom((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);

    setNewPirsom((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "advertising/" + newPirsom.id + "/",
          newPirsom,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setPirsomId(null);
    setError(false);
  };

  return (
    <tr>
      <td>{pirsom.id}</td>
      <td>
        <input
          type="date"
          name="adv_date"
          className="form-control"
          id="adv_date"
          value={newPirsom.adv_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <select
          name="adv_type"
          onChange={handleDDSChange}
          value={newPirsom.adv_type}
        >
          <option value="" selected>
            בחר קטגוריה
          </option>
          {advType?.map((a) => (
            <option key={a.id} value={a.id}>
              {a.title}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="text"
          name="link"
          className="form-control"
          id="link"
          value={newPirsom.link}
          placeholder="קישור לפירסום http://....."
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
